// import React from "react";
// import backgroundImage from "../../assets/new images/Background.png";

// /**
//  * Static Cabil-style Hero with a single smooth curve (no animation)
//  */
// export default function Hero({
//   bgImage = backgroundImage,
//   badgeText = "AI-Powered Career Guidance",
//   titleLines = ["Empower Your Career", "with AI and Human Mentorship"],
//   subtitle = `Cabil connects students, graduates, and professionals with expert mentors — guided by AI insights to help you plan, grow, and succeed in your career.`,
//   primary = { label: "Find a Mentor", onClick: () => {} },
//   secondary = { label: "Try AI Career Coach", onClick: () => {} },
//   waveColor = "#ffffff", // set this to the background color of the next section
// }) {
//   return (
    
//     <section className="relative bg-gray-50 overflow-hidden">
//       {/* Background image */}
//       <div
//         className="relative mt-8 h-[100vh] bg-gray-50 min-h-[560px] w-full bg-center bg-cover"
//         style={{ backgroundImage: `url(${bgImage})` }}
//         aria-label="Hero background"
//       >
//         {/* soft overlay */}
//         <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/25" />

//         {/* content */}
//         <div className="relative z-10 h-full shadow-sm max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
//           <div className="w-full text-center text-white">
//             <div className="inline-flex items-center gap-2 rounded-xl bg-white/15 backdrop-blur px-3.5 py-1.5 text-sm font-medium ring-1 ring-white/30 shadow-md mb-5">
//               <span className="inline-block h-1.5 w-1.5 rounded-xl bg-amber-300" />
//               <span>{badgeText}</span>
//             </div>

//             <h1 className="mx-auto max-w-4xl font-extrabold leading-[1.05] tracking-tight text-4xl sm:text-5xl md:text-6xl">
//               <span className="block">{titleLines[0]}</span>
//               <span className="block mt-1">{titleLines[1]}</span>
//             </h1>

//             <p className="mx-auto mt-5 max-w-3xl text-base sm:text-lg md:text-xl text-white/90">
//               {subtitle}
//             </p>

//             <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
//               <button
//                 onClick={primary.onClick}
//                 className="inline-flex items-center gap-2 rounded-xl bg-white text-slate-800 px-5 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base font-semibold shadow-lg shadow-black/10 hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70 transition"
//               >
//                 {primary.label}
//                 <svg width="16" height="16" viewBox="0 0 24 24" className="-mr-0.5">
//                   <path d="M13 5l7 7-7 7M5 12h14" fill="none" stroke="currentColor" strokeWidth="2" />
//                 </svg>
//               </button>

//               <button
//                 onClick={secondary.onClick}
//                 className="inline-flex items-center rounded-xl border border-white/70 bg-white/10 backdrop-blur px-5 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base font-semibold text-white hover:bg-white/15 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70 transition"
//               >
//                 {secondary.label}
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Static curved wave */}
//        <div className="pointer-events-none absolute bottom-0 left-0 right-0">
//   <svg
//     viewBox="0 0 1440 180"
//     className="block w-full h-[110px] sm:h-[140px] md:h-[170px] text-gray-50"
//     preserveAspectRatio="none"
//     aria-hidden="true"
//   >
//     <path
//       d="M0,120 C360,180 720,60 1080,150 1260,190 1350,155 1440,140 L1440,180 L0,180 Z"
//       fill="currentColor"
//     />
//   </svg>
// </div>
//       </div>
//     </section>
//   );
// }
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Reusable Hero section with background image, overlay, CTAs,
 * and a static curved SVG separator that blends into the next section.
 *
 * Props:
 * - bgImage: string (image URL)
 * - badgeText: string
 * - titleLines: [string, string]  (main title split into two lines)
 * - subtitle: string
 * - primary: { label: string, onClick?: fn, href?: string }
 * - secondary: { label: string, onClick?: fn, href?: string }
 * - curveColor: string (CSS color for the curve fill; should match the next section background)
 * - heightClass: string (Tailwind height class for hero area)
 * - overlayClass: string (Tailwind gradient/overlay class)
 * - roundedButtons: boolean (use rounded-xl instead of rounded-full)
 */




// export default function Hero({
//   bgImage,
//   badgeText = "AI-Powered Career Guidance",
//   titleLines = ["Empower Your Career", "with AI and Human", "Mentorship"],
//   subtitle = `Cabil connects students, graduates, and professionals with expert mentors — guided by AI insights to help you plan, grow, and succeed in your career.`,
//   primary = { label: "Find a Mentor" },
//   secondary = { label: "Try AI Career Coach" },
//   curveColor = "#F9FAFB",                 // default matches Tailwind bg-gray-50
//   heightClass = "h-[100vh] min-h-[560px]", // adjust per page if needed
//   overlayClass = "bg-gradient-to-b from-black/60 via-black/35 to-black/25",
//   roundedButtons = true,
// }) {
//   const Button = ({ item, variant = "solid" }) => {
//     const base =
//       "inline-flex items-center justify-center gap-2 px-5 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70";
//     const radius = roundedButtons ? "rounded-xl" : "rounded-full";
//     if (!item?.label) return null;

//     const content = (
//       <>
//         {item.label}
//         <svg width="16" height="16" viewBox="0 0 24 24" className="-mr-0.5">
//           <path d="M13 5l7 7-7 7M5 12h14" fill="none" stroke="currentColor" strokeWidth="2" />
//         </svg>
//       </>
//     );

//     const classes =
//       variant === "solid"
//         ? `${base} ${radius} bg-white text-slate-800 shadow-lg shadow-black/10 hover:bg-slate-50`
//         : `${base} ${radius} border border-white/70 text-white bg-white/10 backdrop-blur hover:bg-white/15`;

//     // Support href OR onClick
//     return item.href ? (
//       <a href={item.href} className={classes}>{content}</a>
//     ) : (
//       <button onClick={item.onClick} className={classes}>{content}</button>
//     );
//   };

//   return (
//     <section className="relative overflow-hidden bg-gray-50">
//       {/* Background image */}
//       <div
//         className={`relative ${heightClass} w-full bg-center bg-cover`}
//         style={{ backgroundImage: `url(${bgImage})` }}
//         aria-label="Hero background"
//       >
//         {/* Overlay for readability */}
//         <div className={`absolute inset-0 ${overlayClass}`} />

//         {/* Content */}
//         <div className="relative z-10 h-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
//           <div className="w-full text-center text-white">
//             {/* Badge */}
//             {badgeText && (
//               <div className="inline-flex items-center gap-2 rounded-xl bg-white/15 backdrop-blur px-3.5 py-1.5 text-sm font-medium ring-1 ring-white/30 shadow-md mb-5">
//                 <span className="inline-block h-1.5 w-1.5 rounded-xl bg-amber-300" />
//                 <span>{badgeText}</span>
//               </div>
//             )}

//             {/* Title */}
//             <h1 className="mx-auto max-w-4xl font-bold leading-[1.05] tracking-tight text-4xl sm:text-5xl md:text-6xl">
//               <span className="block">{titleLines?.[0]}</span>
//               {titleLines?.[1] && <span className="block mt-1">{titleLines[1]}</span>}
//               {titleLines?.[2] && <span className="block mt-1">{titleLines[2]}</span>}
//             </h1>

//             {/* Subtitle */}
//             {subtitle && (
//               <p className="mx-auto mt-5 max-w-3xl text-base sm:text-lg md:text-xl text-white/90">
//                 {subtitle}
//               </p>
//             )}

//             {/* CTAs */}
//             <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
//               <Button item={primary} variant="solid" />
//               <Button item={secondary} variant="ghost" />
//             </div>
//           </div>
//         </div>

//         {/* Static curved separator — color matches next section */}
//         {/* Static curved wave — seam-proof */}
// <div className="pointer-events-none absolute left-0 right-0 bottom-0 translate-y-[1px]">
//   <svg
//     viewBox="0 0 1440 182"                // taller by 2px
//     className="block w-full h-[110px] sm:h-[140px] md:h-[170px] text-gray-50"
//     preserveAspectRatio="none"
//     aria-hidden="true"

//   >
//     <path
//       // extend the bottom to 182 instead of 180 so it overlaps
//       d="M0,120 C360,180 720,60 1080,150 1260,190 1350,155 1440,140 L1440,182 L0,182 Z"
//       fill="currentColor"                  // make sure this color = next section bg
//     />
//   </svg>
// </div>

//       </div>
//     </section>
//   );
// }


export default function Hero({
  bgImage,
  badgeText,
  titleLines,
  subtitle,
  primary,                  // <-- no defaults
  secondary,                // <-- no defaults
  curveColor = "#F9FAFB",
  heightClass = "h-[100vh] min-h-[560px]",
  overlayClass = "bg-gradient-to-b from-black/60 via-black/35 to-black/25",
  roundedButtons = true,
}) {
  const { t } = useTranslation();
  // Fallback defaults reuse the shared "hero" i18n namespace (same copy used on the Home page).
  const resolvedBadgeText = badgeText ?? t("hero.badge");
  const resolvedTitleLines = titleLines ?? [t("hero.title1"), t("hero.title2"), t("hero.title3")];
  const resolvedSubtitle = subtitle ?? t("hero.subtitle");
  const Button = ({ item, variant = "solid" }) => {
    if (!item) return null;                 // nothing passed → nothing rendered
     const base =
    "group inline-flex   items-center justify-center gap-2 px-5 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base font-semibold transition-all duration-300 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70 shadow-[0_0_10px_rgba(255,255,255,0.3)] hover:shadow-[0_0_20px_rgba(255,255,255,0.6)] hover:scale-105 hover:brightness-110";

    const radius = roundedButtons ? "rounded-xl" : "rounded-full";

    const classes =
      variant === "solid"
        ? `${base} ${radius} bg-white text-slate-800 shadow-lg shadow-black/10 hover:bg-slate-50`
        : `${base} ${radius} border border-white/70 text-white bg-white/10 backdrop-blur hover:bg-white/15`;

    const content = (
      <>
        {item.label}
        <div className="group-hover:translate-x-1 transition-transform duration-300 ease-in-out" 
        >

        <svg width="16" height="16" viewBox="0 0 24 24" className="-mr-0.5">
          <path d="M13 5l7 7-7 7M5 12h14" fill="none" stroke="currentColor" strokeWidth="2" />
        </svg>
        </div>
      </>
    );

    return item.href ? (
      <a href={item.href} className={classes}>{content}</a>
    ) : (
      <button onClick={item.onClick} className={classes}>{content}</button>
    );
  };

  const hasCTAs = Boolean(primary || secondary);

  return (
    <section className="relative overflow-hidden bg-gray-50">
      <div
        className={`relative ${heightClass} w-full bg-center bg-cover`}
        style={{ backgroundImage: bgImage ? `url(${bgImage})` : 'none' }}
        aria-label="Hero background"
        loading="lazy"
      >
        <div className={`absolute inset-0 ${overlayClass}`} />

        <div className="relative z-10 h-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
          <div className="w-full text-center text-white">
            {resolvedBadgeText && (
              <div className="inline-flex items-center gap-2 rounded-xl bg-white/15 backdrop-blur px-3.5 py-1.5 text-sm font-medium ring-1 ring-white/30 shadow-md mb-5">
                <span className="inline-block h-1.5 w-1.5 rounded-xl bg-amber-300" />
                <span>{resolvedBadgeText}</span>
              </div>
            )}

            <h1 className="mx-auto max-w-4xl font-bold leading-[1.05] tracking-tight text-4xl sm:text-5xl md:text-6xl">
              <span className="block">{resolvedTitleLines?.[0]}</span>
              {resolvedTitleLines?.[1] && <span className="block mt-1">{resolvedTitleLines[1]}</span>}
              {resolvedTitleLines?.[2] && <span className="block mt-1">{resolvedTitleLines[2]}</span>}
            </h1>

            {resolvedSubtitle && (
              <p className="mx-auto mt-5 max-w-3xl text-base sm:text-lg md:text-xl text-white/90">
                {resolvedSubtitle}
              </p>
            )}

            {/* CTAs only if provided */}
            {hasCTAs && (
              <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
                {primary && <Button item={primary} variant="solid" />}
                {secondary && <Button item={secondary} variant="ghost" />}
              </div>
            )}
          </div>
        </div>

        {/* Curved separator */}
        <div className="pointer-events-none absolute left-0 right-0 bottom-0 translate-y-[1px]">
          <svg
            viewBox="0 0 1440 182"
            className="block w-full h-[110px] sm:h-[140px] md:h-[170px]"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <path
              d="M0,120 C360,180 720,60 1080,150 1260,190 1350,155 1440,140 L1440,182 L0,182 Z"
              fill={curveColor}
            />
          </svg>
        </div>
      </div>
    </section>
  );
}
